/**
* Card Grid JS
* -----------------------------------------------------------------------------
*
* All the JS for the Card Grid component.
*/

/*
 * Example of importing modules if needed. Like for scroll magic / gsap
 */

// import {gsap} from 'gsap';
// import {ScrollTrigger} from 'gsap/ScrollTrigger.js';
// gsap.registerPlugin( ScrollTrigger );
( function( app ) {
  const COMPONENT = {

    className: 'card-grid',
    selector: function() {
      return '.' + this.className;
    },
    // Fires after common.init, before .finalize and common.finalize
    init: function() {
      let maxHeight = -1;

      $( '.card-grid__container' ).each( function() {
        maxHeight = maxHeight > $( this ).height() ? maxHeight : $( this ).height();
      } );

      $( '.card-grid__container' ).each( function() {
        $( this ).height( maxHeight );
      } );
    },
    finalize: function() {
    },
  };

  // Hooks the component into the app
  app.registerComponent( 'card-grid', COMPONENT );
} )( app );
